import React from 'react';

// Official LyphLine logo (SVG assets in /public).
// dark=true  -> placed on a dark surface, use the reversed (white) logo.
// dark=false -> placed on a light surface, use the full-colour logo.

const heights = { sm: 30, md: 40, lg: 56, xl: 66, hero: 84 };

export const Logo = ({ size = 'md', className = '', dark = true }) => {
  const h = heights[size] || heights.md;
  const src = dark ? '/lyphline-logo-reversed.svg' : '/lyphline-logo.svg';
  return (
    <img
      src={src}
      alt="LyphLine Freeze Dryers"
      style={{ height: `${h}px`, width: 'auto' }}
      className={`block select-none ${className}`}
      draggable={false}
    />
  );
};

export const LogoSmall = ({ className = '', dark = true }) => (
  <Logo size="sm" className={className} dark={dark} />
);

export default Logo;
